import { type FC } from 'react';
import { connect } from 'react-redux';
import SocialLinkRowItemLazy from './SocialLinkRowItemLazy.tsx';
import AppStoreLinkLazy from '../AppStoreLink/AppStoreLinkLazy.tsx';
import { type SocialLinkRowItemProps } from './SocialLinkRowItem.tsx';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import style from './SocialLinkRow-style.scss';

type Props = {
    items: SocialLinkRowItemProps[];
    isMobile: boolean;
};

export const SocialLinkRow: FC<Props> = ({ isMobile, items }) => {
    const rowItems: SocialLinkRowItemProps[] = [...items];

    return (
        <ul
            className={classnames(
                classnames(
                    style.row,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.sassyFontSubHeaderSizeSmallTypeNormal,
                    dibsCss.mtXsmall
                ),
                { [style.isMobile]: isMobile }
            )}
        >
            {rowItems.map((item, i) => (
                <SocialLinkRowItemLazy key={i} {...item} />
            ))}
            {!isMobile && (
                <li>
                    <AppStoreLinkLazy />
                </li>
            )}
        </ul>
    );
};

const mapStateToProps = ({ header }: { header: { isMobile: boolean } }): { isMobile: boolean } => ({
    isMobile: header.isMobile,
});

export default connect(mapStateToProps)(SocialLinkRow);
